import { NavItem } from "../nav-item/nav-item";

export const navItems: NavItem[] = [
  {
    navCap: 'Menú',
  },
  {
    displayName: 'Ficha Motor',
    iconName: 'car',
    bgcolor: 'primary',
    route: '/ficha-motor-admin',
  },
];
